import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyOffers, cancelOffer } from "../../redux/actions/offer";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
  HiOutlineChatAlt2,
  HiOutlineXCircle,
} from "react-icons/hi";

const MyOffers = () => {
  const dispatch = useDispatch();
  const { myOffers, isLoading, success, error } = useSelector(
    (state) => state.offers
  );

  useEffect(() => {
    dispatch(getMyOffers());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      toast.success("Offer cancelled");
      dispatch({ type: "clearOfferSuccess" });
      dispatch(getMyOffers());
    }
    if (error) {
      toast.error(error);
      dispatch({ type: "clearOfferErrors" });
    }
  }, [success, error]);

  const handleCancel = (offerId) => {
    if (window.confirm("Cancel this offer?")) {
      dispatch(cancelOffer(offerId));
    }
  };

  const statusBadge = (status) => {
    const colors = {
      pending: "bg-yellow-100 text-yellow-800",
      admin_reviewed: "bg-blue-100 text-blue-800",
      sent_to_vendor: "bg-indigo-100 text-indigo-800",
      accepted: "bg-green-100 text-green-800",
      rejected: "bg-red-100 text-red-800",
      countered: "bg-purple-100 text-purple-800",
      expired: "bg-gray-100 text-gray-600",
      cancelled: "bg-gray-100 text-gray-600",
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${colors[status] || "bg-gray-100"}`}>
        {status?.replace(/_/g, " ")}
      </span>
    );
  };

  const offers = myOffers || [];

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <HiOutlineChatAlt2 className="w-5 h-5 text-[#086872]" />
          My Offers
        </h2>
        <p className="text-gray-500 text-xs mt-0.5">Track your price offers and their status</p>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#086872]" />
        </div>
      ) : offers.length > 0 ? (
        <div className="space-y-3">
          {offers.map((offer) => (
            <div key={offer._id} className="bg-white rounded-xl border border-gray-200 p-3">
              <div className="flex justify-between items-start">
                <div className="flex gap-3 min-w-0">
                  {offer.product?.images?.[0]?.url && (
                    <img
                      src={offer.product.images[0].url}
                      alt=""
                      className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                    />
                  )}
                  <div className="min-w-0">
                    <Link
                      to={`/product/${offer.product?._id}`}
                      className="text-sm font-medium text-gray-900 hover:text-[#086872] truncate block"
                    >
                      {offer.product?.name}
                    </Link>
                    <div className="flex gap-3 mt-1 text-xs">
                      <span className="text-gray-500">
                        Product: ₹{offer.productPrice}
                      </span>
                      <span className="text-[#086872] font-bold">
                        Your Offer: ₹{offer.offerAmount}
                      </span>
                      {offer.counterAmount && (
                        <span className="text-purple-600 font-bold">
                          Counter: ₹{offer.counterAmount}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1 flex-shrink-0 ml-2">
                  {statusBadge(offer.status)}
                  <span className="text-[10px] text-gray-400">
                    {new Date(offer.createdAt).toLocaleDateString("en-IN")}
                  </span>
                  {(offer.status === "pending" || offer.status === "admin_reviewed") && (
                    <button
                      onClick={() => handleCancel(offer._id)}
                      className="text-xs text-red-500 hover:text-red-700 flex items-center gap-0.5"
                    >
                      <HiOutlineXCircle className="w-3.5 h-3.5" />
                      Cancel
                    </button>
                  )}
                </div>
              </div>
              {offer.vendorResponse && (
                <div className="mt-2 bg-gray-50 rounded-lg p-2 text-xs text-gray-600">
                  <span className="font-medium">Vendor: </span>
                  {offer.vendorResponse}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 text-sm">
          You haven't submitted any offers yet
        </div>
      )}
    </div>
  );
};

export default MyOffers;
